import type { Route } from '@/types/router.ts';

export const DEFAULT_ROUTE = '/clients' satisfies Route;
